export default __webpack_public_path__ + "src/pages/ParkingLane/assets/parking-data-community-map.jpg";